import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--adn-cream)]">
        <div className="text-[var(--adn-text-soft)] text-sm">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (!user.role_selected) return <Navigate to="/select-role" replace />;
  if (roles && roles.length && !roles.includes(user.role)) return <Navigate to="/dashboard" replace />;
  return children;
}
